<template>
  <div v-loading="loading"></div>
</template>

<script>
import { getWxApiToken, getLocalEmpInfo, getUserDataAgreeInfo } from '@/request/api.js'
import { Notify } from 'vant'
import { Base64 } from 'js-base64'
export default {
  data () {
    return {
      module: '304',
      empid: '',
      userid: '',
      loading: true
    }
  },
  created () {
    // 获取路由参数
    // let params = this.$route.query.param || {}
    // if (Object.keys(params).length > 0)    {
    //   params = JSON.parse(Base64.decode(params))
    // }
    // this.module = params.module
    // this.empid = params.empid
    // this.userid = params.userid
    this.module = this.$route.query.module || '304'
    this.empid = this.$route.query.localempid || ''
    this.userid = this.$route.query.localuserid || ''

    getWxApiToken().then(res => {
      sessionStorage.setItem('token', res)
      getUserDataAgreeInfo({
        moduleno: this.module,
        username: 'admin'
      }).then(r => {
        sessionStorage.setItem(
          'usedicfilename',
          r.data[0].usedicfilename.toString()
        )
        sessionStorage.setItem('usepresign', r.data[0].usepresign.toString())
        // this.useagree = r.data[0].useagree
        // this.agree = !r.data[0].useagree
        // this.agreememo = r.data[0].agreememo
        this.goto()
      })
    })
  },
  methods: {
    goto () {
      if (this.module === '201')
      {
        // let redirect = '/seForm?module=' + 201
        // const r =
        //   redirect +
        //   '&autoid=' +
        //   this.empid +
        //   '&localempid=' +
        //   this.empid +
        //   '&localuserid=' +
        //   this.userid
        // this.$router.push(r)
        let param = {
          module: 201,
          autoid: this.empid,
          localempid: this.empid,
          localuserid: this.userid
        }
        this.$router.push({
          path: "/seForm",
          query: { param: Base64.encode(JSON.stringify(param)) }
        });
      } else
      {
        getLocalEmpInfo({ empid: this.empid })
          .then(res => {
            // 直接跳到填写简历信息页面（预入职）
            // let redirect = '/seForm?module=' + 316
            // const r =
            //   redirect +
            //   '&autoid=' +
            //   res.data[0].rsid +
            //   '&localempid=' +
            //   this.empid +
            //   '&localuserid=' +
            //   this.userid
            // this.$router.push(r)
            let param = {
              module: 316,
              autoid: res.data[0].rsid,
              localempid: this.empid,
              localuserid: this.userid
            }
            this.$router.push({
              path: "/seForm",
              query: { param: Base64.encode(JSON.stringify(param)) }
            });
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>

<style>
</style>